import script from "./manage-deals-in-bulk.vue?vue&type=script&setup=true&lang=js"
export * from "./manage-deals-in-bulk.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__